<template>
  <div class="claimList">
    <div class="loading" id="loading" v-show = "loading"><div class="circle"></div></div>
    <div class="main">
		<router-link class="claim-item" :to="{path:'claimDetail',query: {uhid:uhid,order_id:item.order_id}}" v-if="list.length > 0 " v-for="item in list" :key="item.order_id">
			<p class="claim-no">索赔登记号：{{item.order_id}} </p>
			<p class="claim-status" v-if="item.status == 1">索赔受理中</p>
			<p class="claim-status" v-if="item.status == 2">索赔成功</p>
			<p class="claim-status" v-if="item.status == 3">索赔失败</p>
			<div class="claim-icon" v-if="item.status == 1"></div>
			<div class="claim-icon-success" v-if="item.status == 2"></div>
			<div class="claim-icon-failed" v-if="item.status == 3"></div>
		</router-link>
		<div class="empty" v-if="list.length == 0">
			<div class="icon"></div>
			<p class="empty-text">您还没有进行任何索赔</p>	
        </div>
	</div>
  </div>
</template>

<script>
const AES = require('@/lib/Utils/AES').default
export default {
  name: 'claimList',
  data () {
    return {
        list : '',
        uhid : '',
        loading:false
    }
  },
  mounted:function(){
      var _self = this;
      Utils.Bridge.call('getAppInfo',{
        success:function(o){
            _self.uhid = o.uhid;
            
            _self.loading = true;
          let data = {
            "dhid":o.dhid,
            "uhid":o.uhid,
            "vcode":o.vcode
          }
          let ed = AES.Encrypt( JSON.stringify(data), AES.obj())
      
            _self.$http.post(_host + '/safe/get_list',{
              ed: ed
            },{
                emulateJSON: true
            }).then(function(response){
                _self.loading = false;
                var json = response.body;
                if(json.c=='0000'){
                    _self.list = json.m;
                }else{
                    safe.model({
                        title:'温馨提示',
                        content:json.m,
                        foot:'我知道了'
                    });
                    safe.bindModelEvent();
                }
            })
        }
    });
    _self.$trace.enterTraceDone({page: 8})
  }
}
</script>

<style scoped>
.claimList{padding-top: 15px;}
.main{margin-top: 0;position: relative;}
.main .empty{
    position: fixed;
    margin-top: -53px;
    width: 100%;
    height: 106px;
    top: 50%;
}
.main .empty .icon{
    width: 50px;
    height: 60px;
    margin: 0 auto;
    background-image: url(../images/empty.png);
    background-repeat: no-repeat;
    -webkit-background-size: 100%;
    background-size: 100%;    
}
.main .empty-text{text-align: center; width: 100%;padding: 0;}
.claim-item{position: relative;display: block;border-top:6px solid #6ab8f8;background-color: #ffffff;text-decoration: none;}
.claim-item p{line-height: 46px;}
.claim-item .claim-no,.claim-item .claim-status{font-size: 13px;width: 65%;padding-right: 0;}
.claim-item .claim-no{border-bottom:1px solid #f2f2f2;color: #666666;}
.claim-item .claim-status{color: #f55e52;}
.claim-item .claim-icon,.claim-item .claim-icon-success,.claim-item .claim-icon-failed{
    position: absolute;
    width: 60px;
    height: 60px;
    top:16px;
    right:22px;
    background-repeat: no-repeat;
    -webkit-background-size: 100%;
    background-size: 100%;    
}
.claim-item img{width: 20%; position: absolute; right: 3%; top: 15px;}
.claim-item .claim-icon{
    background-image: url(../images/claim.png);
}
.claim-item .claim-icon-success{
    background-image: url(../images/claim_success.png);
}
.claim-item .claim-icon-failed{
    background-image: url(../images/claim_failed.png);
}
.claim-item.success .claim-status{color: #0285f0;}
.claim-item.failed .claim-status{color: #B6B6B6;}
</style>



// WEBPACK FOOTER //
// ClaimList.vue?77e05699